import FF from "@/components/forms/FormField.module.css";
import type { ReactNode } from "react";

export function RadioGroupDiv({ children }: { children: ReactNode }) {
    return <div className={FF.FormFieldRadioGroup}>{children}</div>;
}
